// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { TABBAR_ITEM_TRANSITION } from '../../../constants/ui/tabbar';
import theme from '../../../styled-components/dark';

const SvgElement = styled.svg`
  ${({ $isActive }) =>
    $isActive
      ? css`
          --background-path-fill: ${theme.TabBar.Button.default.active.color};
          --background-border-path-fill: transparent;
          --background-inner-border-path-1-fill: transparent;
          --background-inner-border-path-2-fill: transparent;
          --background-inner-border-path-3-fill: transparent;
        `
      : css`
          --background-path-fill: transparent;
          --background-border-path-fill: ${theme.TabBar.Button.default.passive.color};
          --background-inner-border-path-1-fill: ${theme.TabBar.Button.default.passive.color};
          --background-inner-border-path-2-fill: ${theme.TabBar.Button.default.passive.color};
          --background-inner-border-path-3-fill: ${theme.TabBar.Button.default.passive.color};
        `}
`;

const sharedPathTransition = css`
  transition: fill ${TABBAR_ITEM_TRANSITION}ms ease-in-out;
`;

const BackgroundPath = styled.path`
  ${sharedPathTransition}
  fill: var(--background-path-fill, transparent);
`;

const BackgroundInnerBorderPath1 = styled.path`
  ${sharedPathTransition}
  fill: var(--background-inner-border-path-1-fill, transparent);
`;

const BackgroundInnerBorderPath2 = styled.path`
  ${sharedPathTransition}
  fill: var(--background-inner-border-path-2-fill, transparent);
`;

const BackgroundInnerBorderPath3 = styled.path`
  ${sharedPathTransition}
  fill: var(--background-inner-border-path-3-fill, transparent);
`;

const BackgroundBorderPath = styled.path`
  ${sharedPathTransition}
  fill: var(--background-border-path-fill, transparent);
`;

type MyBetsIconSvgAsComponentProps = {
  isActive?: boolean;
  className?: string;
};

const MyBetsIconSvgAsComponent = ({ className, isActive = false }: MyBetsIconSvgAsComponentProps) => {
  return (
    <SvgElement className={className} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" $isActive={isActive}>
      <BackgroundPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 22C5 24.7614 7.23858 27 10 27H20C22.7614 27 25 24.7614 25 22H22.1429C21.5906 22 21.1429 21.5523 21.1429 21C21.1429 20.4477 21.5906 20 22.1429 20H25V8C25 5.23857 22.7614 3 20 3H10C7.23858 3 5 5.23857 5 8V20H7.85714C8.40943 20 8.85714 20.4477 8.85714 21C8.85714 21.5523 8.40943 22 7.85714 22H5ZM18.2071 12.7929C17.8166 12.4024 17.1834 12.4024 16.7929 12.7929L15 14.5858L14.2071 13.7929C13.8166 13.4024 13.1834 13.4024 12.7929 13.7929C12.4024 14.1834 12.4024 14.8166 12.7929 15.2071L14.2929 16.7071C14.6834 17.0976 15.3166 17.0976 15.7071 16.7071L18.2071 14.2071C18.5976 13.8166 18.5976 13.1834 18.2071 12.7929ZM11 8C11 7.44772 11.4477 7 12 7H18C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9H12C11.4477 9 11 8.55228 11 8ZM12.1429 20C11.5906 20 11.1429 20.4477 11.1429 21C11.1429 21.5523 11.5906 22 12.1429 22H17.8571C18.4094 22 18.8571 21.5523 18.8571 21C18.8571 20.4477 18.4094 20 17.8571 20H12.1429Z"
      />
      <BackgroundInnerBorderPath1 d="M18.2071 12.7929C17.8166 12.4024 17.1834 12.4024 16.7929 12.7929L15 14.5858L14.2071 13.7929C13.8166 13.4024 13.1834 13.4024 12.7929 13.7929C12.4024 14.1834 12.4024 14.8166 12.7929 15.2071L14.2929 16.7071C14.6834 17.0976 15.3166 17.0976 15.7071 16.7071L18.2071 14.2071C18.5976 13.8166 18.5976 13.1834 18.2071 12.7929Z" />
      <BackgroundInnerBorderPath2 d="M11 8C11 7.44772 11.4477 7 12 7H18C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9H12C11.4477 9 11 8.55228 11 8Z" />
      <BackgroundInnerBorderPath3 d="M13 20C12.4477 20 12 20.4477 12 21C12 21.5523 12.4477 22 13 22H17C17.5523 22 18 21.5523 18 21C18 20.4477 17.5523 20 17 20H13Z" />
      <BackgroundBorderPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 27C7.23858 27 5 24.7614 5 22V8C5 5.23857 7.23858 3 10 3H20C22.7614 3 25 5.23857 25 8V22C25 24.7614 22.7614 27 20 27H10ZM7 20V8C7 6.34315 8.34315 5 10 5H20C21.6569 5 23 6.34315 23 8V20H21C20.4477 20 20 20.4477 20 21C20 21.5523 20.4477 22 21 22L23 22C23 23.6569 21.6569 25 20 25H10C8.34315 25 7 23.6569 7 22H9C9.55228 22 10 21.5523 10 21C10 20.4477 9.55229 20 9 20H7Z"
      />
    </SvgElement>
  );
};

export default MyBetsIconSvgAsComponent;
